import { network } from 'services/network';

export const getAcrossVersionHashCodeConfig = (projectId) => {
    return network.get(`api/bo/getAcrossVersionHashCodeConfig?projectId=${projectId}`).then((response) => {
        return response.data;
    });
};
